<template>
  <section class="Exp" id="Experience">
    <h1 id="expCarousel">Summary of my experience</h1>

    <transition name="fade">
      <carousel-3d
        v-if="(showExpCarousel && !loading) && experiences.length > 0"
        :count="experiences.length"
        :controls-visible="true"
        :perspective="0"
        :display="3"
        :loop="false"
        :width="700"
        :height="460"
        :border="0"
        :clickable="false"
        :animationSpeed="250"
      >
        <slide v-for="(experience, i) in experiences" v-bind:index="i" v-bind:key="i">
          <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
            <div class="experienceCard" :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0)}">

              <div class="cardHeader">
                <div>
                  <img :src="experience.placeLogo" alt="">
                </div>

                <div>
                  <h2>{{experience.place}}</h2>
                  <span>{{experience.role}}</span>
                  <p>{{experience.placeDesc}}</p>
                </div>
              </div>

              <div class="cardBody">
                <p v-html="experience.roleDesc"></p>
              </div>

            </div>
          </template>
        </slide>
      </carousel-3d>
    </transition>

    <p v-if="(showExpCarousel && !loading) && experiences.length > 0" class="p1">You will have each experience in detail in the <router-link to="/experience">Experience section</router-link></p>
    <p v-if="(showExpCarousel && !loading) && experiences.length > 0" class="p2">See about my experience as a developer in the <router-link to="/experience">Experience section</router-link></p>

    <div class="spinerParent" v-if="loading">
      <img src="../assets/spinb.png" />
    </div>

    <fetchError :style="{display:fetchErr?'flex':'none'}" :Exception="fetchErr" />

  </section>
</template>

<script>
import Request from "../mixins/axiosRequest.js";
import { Carousel3d, Slide } from 'vue-carousel-3d';
import fetchError from "./Small/fetchError.vue";

export default {
  name: "Experience",

  data() {
    return {
      experiences: [],
      loading: true,
      showExpCarousel: false,
      fetchErr: null
    };
  },

  methods: {
    async getExperiences() {
      let data = await Request.axiosGet("/api/experience", this.client);
      if(data.status) {
        this.experiences = data.data;
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
      this.addListenner();
    },

    isInViewport() {
      let el = document.getElementById("expCarousel");
      if(el) {
        const rect = el.getBoundingClientRect();
        if(rect) {
          this.showExpCarousel = (
            rect.bottom <= (window.innerHeight -250 || document.documentElement.clientHeight -250) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }
      }
    },

    addListenner() {
      document.addEventListener('scroll', this.isInViewport, {passive:true});
    },
    removeListenner() {
      document.removeEventListener('scroll', this.isInViewport, {passive:true});
    }
  },

  mounted() {
    this.getExperiences();
    this.loading = true;
  },

  destroyed() {
    this.removeListenner();
  },

  components: {
    Carousel3d,
    Slide,
    fetchError
  }
};
</script>

<style scoped lang="scss">
.Exp {
  margin: 15px auto 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  max-width: 1366px;
  min-height: 575px;
  background: transparent;

  padding-top: 1.5em;

  /* min-height: 60vh; */
}

h1 {
  letter-spacing: 3px;
  color: #000;
  text-align: center;
  width: 100%;
  cursor: default;
  font-size: 45px;
  margin: 0;
}

.carousel-3d-container {
  width: 95%;
  min-height: 400px;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 25px;
}

.carousel-3d-slide {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: default;
  max-height: 420px;

}

.experienceCard {
  margin: 15px 10px;
}

.experienceCard .cardHeader {
  display: flex;
  align-items: center;
  min-height: 20px;
  overflow: hidden;
  margin: 40px 60px 15px 60px;

  img {
    height: 125px;
    width: 125px;
    border-radius: 100%;
    object-fit: scale-down;
    margin-right: 15px;
  }
  p {
    font-size: 12.5px;
    text-align: justify;
    max-width: 90%;
    margin-top: 5px;
    padding-left: 15px;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4; /* number of lines to show */
    line-clamp: 2; 
    -webkit-box-orient: vertical;
  }
  h2 {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  span {
    font-style: italic;
    font-weight: bold;
    padding-left: 15px;
    font-size: 19px;
  }
}

.experienceCard .cardBody {
  min-height: 200px;
  max-height: 200px;
  overflow-y: visible;
  margin: 0 40px;
  p {
    text-align: justify;
    line-height: 21px;
    font-size: 14.5px;
    margin-bottom: 10px;

    span {
      font-weight: bold;
      padding: 0px 4px;
    }
  }
}

.right-1 {
  opacity: 0.75 !important;
}

.left-1 {
  opacity: 0.75 !important;
}

.next {
  color: #000;
}

.spinerParent {
  margin: auto 0 auto 0;
}

p {
  font-size: 17px;
  color: #000;
  a {
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
    font-weight: bold;
    padding: 2px 5px;
    font-size: 17px;
  }
}

.p2 {
  display: none;
}

@media (prefers-color-scheme: dark) {
  .carousel-3d-container {
    color: #fff;
  }
  .carousel-3d-slide {
    background-color: #2c2b2b;
  }

  .carousel-3d-slide.current{
    box-shadow: rgb(0, 0, 0) 0px 0px 7px 1px;
  }

  .right-1 {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 15px;
  }

  .left-1 {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 15px;
  }

  .experienceCard .cardHeader {
    img {
      background-color: #e0dede;
    }
    p {
      color: rgba(255, 255, 255, 0.6);
    }
  }

  .experienceCard .cardBody {
    p {
      color: #fff;

      span {
        color: #000;
        background-color: #e0dede;
      }
    }
  }

}

@media (prefers-color-scheme: light) {
  .carousel-3d-container {
    color: #000;
  }
  .carousel-3d-slide {
    background-color: #eeeeee;
  }

  .carousel-3d-slide.current{
    box-shadow: rgb(116, 116, 116) 0px 0px 7px 1px;
  }

  .right-1 {
    box-shadow: rgba(116, 116, 116, 0.5) 0px 0px 15px;
  }

  .left-1 {
    box-shadow: rgba(116, 116, 116, 0.5) 0px 0px 15px;
  }

  .experienceCard .cardHeader {
    img {
      background-color: #1e1e1e;
    }
    p {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .experienceCard .cardBody {
    p {
      color: #000;

      span {
        color: #000;
        background-color: #1e1e1e;
      }
    }
  }

}

@media screen and (max-width: 780px) {
  .Exp {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: unset;
  }

  h1 {
    display: none;
  }

  .carousel-3d-container {
    display: none;
  }

  .p1 {
    display: none;
  }

  .p2 {
    display: initial;
  }

}

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .3s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

</style>
